__turbopack_context__.v({
  "active": "DetailedSlider-module___oor3G__active",
  "navBtn": "DetailedSlider-module___oor3G__navBtn",
  "navButtons": "DetailedSlider-module___oor3G__navButtons",
  "primary": "DetailedSlider-module___oor3G__primary",
  "secondary": "DetailedSlider-module___oor3G__secondary",
  "slide": "DetailedSlider-module___oor3G__slide",
  "slideContent": "DetailedSlider-module___oor3G__slideContent",
  "slideContentBody": "DetailedSlider-module___oor3G__slideContentBody",
  "slideContentGroup": "DetailedSlider-module___oor3G__slideContentGroup",
  "slideContentHeading": "DetailedSlider-module___oor3G__slideContentHeading",
  "slideContentIndicator": "DetailedSlider-module___oor3G__slideContentIndicator",
  "slideImage": "DetailedSlider-module___oor3G__slideImage",
  "sliderBox": "DetailedSlider-module___oor3G__sliderBox",
  "sliderContainer": "DetailedSlider-module___oor3G__sliderContainer",
  "sliderWrapper": "DetailedSlider-module___oor3G__sliderWrapper",
  "slides": "DetailedSlider-module___oor3G__slides",
  "success": "DetailedSlider-module___oor3G__success",
});
